import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import networkErrorHandler from "./lib/network-error-handler.js";

// ייבוא הטיפול בשגיאות רשת
console.log("SHA SHA - Loading with network error handling...");

// בדיקת חיבור ראשונית
networkErrorHandler.checkConnection().then(isConnected => {
  console.log("חיבור לשרת:", isConnected ? "פעיל" : "לא זמין");
});

// אפשרות 1: עם loading state
const rootElement = document.getElementById("root");
if (rootElement) {
  // הוספת loading indicator
  rootElement.innerHTML = `
    <div style="
      display: flex; 
      justify-content: center; 
      align-items: center; 
      height: 100vh; 
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-family: Arial, sans-serif;
    ">
      <div style="text-align: center;">
        <div style="
          width: 50px; 
          height: 50px; 
          border: 3px solid rgba(255,255,255,0.3); 
          border-top: 3px solid white; 
          border-radius: 50%; 
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        "></div>
        <h2>SHA SHA</h2>
        <p>טוען תכשיטים בעבודת יד...</p>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;

  // יצירת root עם error boundary
  const root = createRoot(rootElement);
  
  root.render(
    <StrictMode>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <App />
      </BrowserRouter>
    </StrictMode>
  );
} else {
  console.error("Root element not found!");
}

// אפשרות 2: רישום Service Worker רק בפרודקשן; בפיתוח נבצע ניקוי אם קיים
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  } else {
    // DEV: ודא שאין SW שמקלקל קבצים ישנים/קאש
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => {
        reg.unregister().then(() => {
          console.log('DEV: Unregistered stale Service Worker');
        });
      });
      if ('caches' in window) {
        caches.keys().then((keys) => {
          keys.forEach((key) => caches.delete(key));
        });
      }
    });
  }
}

// אפשרות 3: עם performance monitoring
if (import.meta.env.PROD) {
  // Performance monitoring
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.entryType === 'navigation') {
        console.log('Page load time:', entry.loadEventEnd - entry.loadEventStart);
      }
    }
  });
  observer.observe({ entryTypes: ['navigation'] });
} 